export enum ConcurrencyTarget {
  Encounter = "Encounter",
  Changeset = "Changeset",
}
